import React from "react";
import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <>
      <style>{styles}</style>

      <footer className="site-footer">
        <div className="site-footer-inner">
          <Link
            to="/"
            className="site-footer-brand"
            aria-label="Tallarge 首頁"
          >
            TALLARGE<span>.</span>
          </Link>

          <div className="site-footer-line" />

          <div className="site-footer-links">
            <Link to="/privacy">
              隱私權政策
            </Link>

            <Link to="/terms">
              使用條款
            </Link>
          </div>
        </div>
      </footer>
    </>
  );
}

const styles = `
.site-footer,
.site-footer * {
  box-sizing: border-box;
}

.site-footer {
  width: 100%;
  margin-top: auto;

  background: #ffffff;

  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "SF Pro Display",
    "SF Pro Text",
    "PingFang TC",
    "Noto Sans TC",
    "Microsoft JhengHei",
    Arial,
    sans-serif;

  -webkit-font-smoothing: antialiased;
}

.site-footer-inner {
  width: min(1180px, calc(100% - 48px));

  margin: 0 auto;

  padding:
    34px 0
    28px;
}


/* =========================================================
   BRAND
   ========================================================= */

.site-footer-brand {
  display: inline-block;

  color: #171a1d;

  font-size: 24px;
  font-weight: 500;

  line-height: 1;

  letter-spacing: -0.04em;

  text-decoration: none;
}

.site-footer-brand span {
  color: #ff7518;
}


/* =========================================================
   DIVIDER
   ========================================================= */

.site-footer-line {
  width: 100%;
  height: 1px;

  margin-top: 20px;

  background: #4a4a4a;
}


/* =========================================================
   LINKS
   ========================================================= */

.site-footer-links {
  display: flex;

  align-items: center;
  justify-content: flex-end;

  gap: 34px;

  padding-top: 10px;
}

.site-footer-links a {
  color: #171a1d;

  font-size: 13px;
  font-weight: 600;

  line-height: 1.4;

  text-decoration: none;

  transition:
    color 0.18s ease;
}

.site-footer-links a:hover {
  color: #ff7518;
}


/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 620px) {
  .site-footer-inner {
    width: calc(100% - 34px);

    padding:
      27px 0
      23px;
  }

  .site-footer-brand {
    font-size: 21px;
  }

  .site-footer-line {
    margin-top: 17px;
  }

  .site-footer-links {
    gap: 22px;

    padding-top: 9px;
  }

  .site-footer-links a {
    font-size: 12px;
  }
}
`;